<script setup>
import { useI18n } from 'vue-i18n'

defineProps({
  visible: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['close'])

const { t } = useI18n()

const handleClose = () => {
  emit('close')
}
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform -translate-y-full opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform -translate-y-full opacity-0"
  >
    <div
      v-if="visible"
      class="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg"
      role="alert"
    >
      <div class="container mx-auto px-4 py-3 flex items-center justify-center gap-4">
        <div class="flex items-center gap-3 flex-1 min-w-0 justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p class="text-sm font-medium">
            {{ t('beta.banner_text') }}
          </p>
        </div>
        <button
          @click="handleClose"
          class="p-1.5 text-white/80 hover:text-white transition-colors flex-shrink-0"
          :aria-label="t('beta.banner_close')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </Transition>
</template>
